/* eslint-disable */
export function isIinValid(iin){
    return iin != null && /^[0-9]{12}$/.test(iin);
}

export function isPasswordValid(password){
    return password != null && /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])[a-zA-Z0-9\W_]{8,}$/.test(password);
}

